export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple,
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple,
  },
  {
    title: that.$l('INDEX.choose_fabric_fabricNo') || '编号',
    field: 'fabricNo',
    width: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_factoryFabricNumber') || '工厂面料编号',
    field: 'factoryNumber',
    width: 200,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_fabricName') || '名称',
    field: 'fabricName',
    minWidth: 400,
    slots: { default: 'fabricName' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_content') || '成分',
    field: 'fabricContent',
    minWidth: 400,
    slots: { default: 'fabricContent' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_wid') || '门幅',
    field: 'wid',
    width: 120,
    slots: { default: 'wid' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_weight') || '克重',
    field: 'fabricWeight',
    width: 120,
    slots: { default: 'fabricWeight' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_agent') || '业务员',
    field: 'fabricAgentName',
    width: 150,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.choose_fabric_supName') || '供应商',
    field: 'supName',
    minWidth: 300,
    showHeaderOverflow: true,
  },
]
